<script lang="ts">
    import type { CartItem } from '$lib/def/food-menu';
	import { hasAlcohol, type CartData, type PromoBubble } from '$lib/serv/groc-cart';
	import { lowStockChecker } from '$lib/ui/home/groc/Cart.svelte';
    import Cart from './Cart.svelte';

	export let cartData: Partial<CartData>;
	const d: Date = new Date();
	const liquorStartingHour = 15;
	const liquorEndingHour = 20;
	const pausedMsg = "Delivery paused. We'll take your order as soon as the next driver becomes available.";
	const liqMsg = "If you'd like to checkout now, remove liquor from your cart. \n\nAlternatively, you can wait for liquor delivery to open and then checkout your order.";
	const testHour = 21;
	function generatePromoFormat(arr: PromoBubble[]) {
		return arr.map((i) => {
			const bold = ` <strong>${i.text}</strong> `;
			const highlight = ` <em>${i.text}</em> `;
			return i.type === 'bold' ? bold : i.type === 'highlight' ? highlight : i.text;
		});
	}
</script>

{#if cartData?.items}

	<!--{@const hasAlcohol = cartData.items.filter((item) => item.is_alcohol === true).length > 0}-->

	<!-- ==================== CART PROMO NOTIFICATIONS ==================== -->
	{#if cartData.promotion?.promotional_bubble && cartData.promotion?.promotional_bubble.length > 0}
		{@const bubbleData = cartData.promotion.promotional_bubble}
		{@const formattedBubble = generatePromoFormat(bubbleData)}
		<div class="notification-promos">
			<span>
				{#each formattedBubble as b, idx }
					{@html formattedBubble[idx]}
				{/each}
			</span>
		</div>
	{/if}

	<!-- ==================== CART STATUS NOTIFICATIONS ==================== -->
	{#if lowStockChecker(cartData.items).hasLowStock}
		<div class="notification-cart-status">
			<h6 class="label-m m-0">
				{lowStockChecker(cartData.items).amt} item{lowStockChecker(cartData.items).amt > 1 ? 's' : ''} 
				you have added {lowStockChecker(cartData.items).amt > 1 ? 'are' : 'is'} running low
			</h6>
			<span class="label-s">Select a backup item in case it is sold out</span>
		</div>
	{/if}
	
	{#if (!cartData.can_check_out && cartData.delivery_status != "available")}
		<div class="notification-cart-status">
			<h6 class="label-m m-0">We're experiencing high demand</h6>
			<span class="label-s">{ pausedMsg }</span>
		</div>	
	{/if}
	
	{#if hasAlcohol(cartData.items) && cartData.alcohol_checkout_blocked}
		<div class="notification-cart-status">
			<h6 class="label-m m-0">Liquor delivery</h6>
			<span class="label-s">{ liqMsg }</span>
		</div>
		<!--
		{:else if cartData.has_alcohol && d.getHours() < liquorStartingHour || d.getHours() >= liquorEndingHour}
			<div class="notification-cart-status">
				<h6 class="label-m m-0">Liquor delivery from tomorrow 11:00</h6>
				<span>{ liqMsg }</span>
			</div>-->
	{/if}

{/if}